import template from './inputGroup.html' with { type: 'html' };

export default {
	name: 'CInputGroup',
	props: {
		errors: {
			type: Array,
			default: () => []
		},
		note: {
			type: String,
			default: ''
		},
		values: {
			type: Array,
			default: () => []
		},
		warning: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			hasFocus: false
		};
	},
	computed: {
		isFilled() {
			return this.values.every((value) => !['', null].includes(value));
		}
	},
	methods: {
		onBlur() {
			this.hasFocus = false;
		},
		onFocus() {
			this.hasFocus = true;
		}
	},
	template
};
